var render = function render(){var _vm=this,_c=_vm._self._c;return _c('uiv-popover',_vm._g(_vm._b({ref:"uivPopup",on:{"show":_vm.onShow,"hide":_vm.onHide}},'uiv-popover',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_vm._v(" "),_c('template',{slot:"popover"},[_vm._t("popover")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }